import React from "react";
import { InlineWidget } from "react-calendly";

export default function CalendlyBooking() {
  return (
    <div className="calendly-wrapper calendly-wrapper--split">
      <InlineWidget
        url="https://calendly.com/mlveda-team/support"
        styles={{
          height: "750px",
          minWidth: "1000px",
          width: "100%",
        }}
      />
    </div>
  );
}
